import { lazy } from 'react';
import { IconType, IconWrap } from '@tools/ui/dime';
import type { AppRouter } from '@tools/ui/types';
import useT from '@tools/ui-hooks/useT';
import config from '../config/config';
import { RecoAppWrapper } from '../pages/reco/components/reco-app-wrapper';
import { jpmReportRoutes } from '../pages/reco/routes/jpm-report.routes';
import { vendorRoutes } from '../pages/reco/routes/vendors.routes';

const { prefixPath } = config;

const CustomerFunds = lazy(
  () =>
    import(
      /* webpackChunkName: "RecoRoutes" */ '../pages/reco/pages/new/customer-funds'
    )
);

const RevenueAccounts = lazy(
  () =>
    import(
      /* webpackChunkName: "RecoRoutes" */ '../pages/reco/pages/new/revenue-accounts'
    )
);

const CardCostModule = lazy(
  () =>
    import(
      /* webpackChunkName: "RecoRoutes" */ '../pages/reco/pages/new/card-cost'
    )
);

const VendorBalanceModule = lazy(
  () =>
    import(/* webpackChunkName: "RecoRoutes" */ '../pages/reco/pages/vendors')
);

const ReconciliationGapsModule = lazy(
  () =>
    import(
      /* webpackChunkName: "RecoRoutes" */ '../pages/reco/pages/gaps/index'
    )
);

const JPMReportModule = lazy(
  () =>
    import(
      /* webpackChunkName: "RecoRoutes" */ '../pages/reco/pages/jpm-report/index'
    )
);

const TransferSearchModule = lazy(
  () =>
    import(
      /* webpackChunkName: "RecoRoutes" */ '../pages/reco/pages/transfer-search/transfer-search'
    )
);

const CustomerFundsPage = () => {
  const { t } = useT();

  return (
    <RecoAppWrapper title={t('reco.customerFundsTitle')}>
      <CustomerFunds />
    </RecoAppWrapper>
  );
};

const RevenueAccountsPage = () => {
  const { t } = useT();

  return (
    <RecoAppWrapper title={t('reco.revenueAccountsTitle')}>
      <RevenueAccounts />
    </RecoAppWrapper>
  );
};

const CardCostPage = () => {
  const { t } = useT();

  return (
    <RecoAppWrapper title={t('reco.cardCostTitle')}>
      <CardCostModule />
    </RecoAppWrapper>
  );
};

export const recoRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [`${prefixPath}/`, `${prefixPath}/*`]
    },
    {
      name: 'Customer Funds',
      path: `${prefixPath}/customer-funds`,
      icon: () => <IconWrap type={IconType.RecoCustomerFunds} />,
      exact: false,
      component: CustomerFundsPage,
      pages: []
    },
    {
      name: 'Revenue Accounts',
      path: `${prefixPath}/revenue-accounts`,
      icon: () => <IconWrap type={IconType.RecoRevenueAccounts} />,
      exact: false,
      component: RevenueAccountsPage,
      pages: []
    },
    {
      name: 'Card Cost',
      icon: () => <IconWrap type={IconType.Card} />,
      path: `${prefixPath}/card-cost`,
      exact: false,
      component: CardCostPage,
      pages: []
    },
    {
      name: 'Vendor-Balance',
      path: `${prefixPath}/vendorBalance`,
      icon: () => <IconWrap type={IconType.RecoVendorBalance} />,
      exact: false,
      component: VendorBalanceModule,
      pages: vendorRoutes
    },
    {
      name: 'JPM Report',
      path: `${prefixPath}/jpm-report`,
      icon: () => <IconWrap type={IconType.RecoJPMReport} />,
      exact: false,
      component: JPMReportModule,
      pages: jpmReportRoutes
    },
    {
      name: 'Reconciliation Gaps',
      path: `${prefixPath}/gaps`,
      icon: () => <IconWrap type={IconType.RecoGaps} />,
      exact: false,
      component: ReconciliationGapsModule,
      pages: []
    },
    {
      name: 'Transfer Search',
      path: `${prefixPath}/transfer-search`,
      icon: () => <IconWrap type={IconType.RecoTransferSearch} />,
      exact: false,
      component: TransferSearchModule,
      pages: []
    }
  ]
};
